/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRemoteMcpServerScopesSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRemoteMcpServerScopesSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRemoteMcpServerScopesSecurity = {
  option1?: GetRemoteMcpServerScopesSecurityOption1 | undefined;
  option2?: GetRemoteMcpServerScopesSecurityOption2 | undefined;
};

export type GetRemoteMcpServerScopesRequest = {
  /**
   * The ID of the remote-backed MCP server.
   */
  mcpServerId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRemoteMcpServerScopesSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRemoteMcpServerScopesSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetRemoteMcpServerScopesSecurityOption1$Outbound,
    GetRemoteMcpServerScopesSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getRemoteMcpServerScopesSecurityOption1ToJSON(
  getRemoteMcpServerScopesSecurityOption1:
    GetRemoteMcpServerScopesSecurityOption1,
): string {
  return JSON.stringify(
    GetRemoteMcpServerScopesSecurityOption1$outboundSchema.parse(
      getRemoteMcpServerScopesSecurityOption1,
    ),
  );
}

/** @internal */
export type GetRemoteMcpServerScopesSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRemoteMcpServerScopesSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetRemoteMcpServerScopesSecurityOption2$Outbound,
    GetRemoteMcpServerScopesSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getRemoteMcpServerScopesSecurityOption2ToJSON(
  getRemoteMcpServerScopesSecurityOption2:
    GetRemoteMcpServerScopesSecurityOption2,
): string {
  return JSON.stringify(
    GetRemoteMcpServerScopesSecurityOption2$outboundSchema.parse(
      getRemoteMcpServerScopesSecurityOption2,
    ),
  );
}

/** @internal */
export type GetRemoteMcpServerScopesSecurity$Outbound = {
  Option1?: GetRemoteMcpServerScopesSecurityOption1$Outbound | undefined;
  Option2?: GetRemoteMcpServerScopesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetRemoteMcpServerScopesSecurity$outboundSchema: z.ZodMiniType<
  GetRemoteMcpServerScopesSecurity$Outbound,
  GetRemoteMcpServerScopesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetRemoteMcpServerScopesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetRemoteMcpServerScopesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getRemoteMcpServerScopesSecurityToJSON(
  getRemoteMcpServerScopesSecurity: GetRemoteMcpServerScopesSecurity,
): string {
  return JSON.stringify(
    GetRemoteMcpServerScopesSecurity$outboundSchema.parse(
      getRemoteMcpServerScopesSecurity,
    ),
  );
}

/** @internal */
export type GetRemoteMcpServerScopesRequest$Outbound = {
  mcp_server_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRemoteMcpServerScopesRequest$outboundSchema: z.ZodMiniType<
  GetRemoteMcpServerScopesRequest$Outbound,
  GetRemoteMcpServerScopesRequest
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getRemoteMcpServerScopesRequestToJSON(
  getRemoteMcpServerScopesRequest: GetRemoteMcpServerScopesRequest,
): string {
  return JSON.stringify(
    GetRemoteMcpServerScopesRequest$outboundSchema.parse(
      getRemoteMcpServerScopesRequest,
    ),
  );
}
